<template>
    <v-radio-group v-model="value" :label="label" :rules="rules">
        <v-radio
                v-for="n in genders"
                :key="n.value"
                :label="n.text"
                :value="n.value"
                color="primary"
        ></v-radio>
    </v-radio-group>
</template>

<script>
    import utils from '../utils';

    export default {
        name: "GenderSelectionField",
        props: {
            label: {
                type: String,
                default: 'Spol'
            },
            value: {
                type: String
            },
            rules: {
                default: []
            }
        },
        watch: {
            value() {
                this.$emit('input', this.value);
            }
        },
        data() {
            return {
                'genders': utils.genders
            }
        }
    }
</script>

<style scoped>
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
    }

</style>